/**
 * The hairline of brand colour across the very top of every screen a person signs in through —
 * the app chrome and the login page both, which is why it is its own component rather than a
 * div inside TopBar: there is no nav bar to hang it off of before you are signed in.
 *
 * Fixed rather than in flow, so it survives scrolling and needs no cooperation from whatever
 * layout it lands in — the login shell is a centred flex column and the app is a header plus a
 * scrolling page, and neither has to know about it. Everything below that pins itself to the
 * top of the viewport offsets by --brand-rule-h (see .topbar, .board-page .page-head).
 *
 * Not on the wall displays: /wall-view and /tv render outside the app shell on purpose, and a
 * band of saturated colour across a board being read from ten metres away is the kind of chrome
 * those screens exist without.
 */
export default function BrandRule() {
  return <div className="brand-rule" aria-hidden="true" />
}
